/* product-card-carousel.js - VERSIÓN FINAL SIN DUPLICADOS */
(function () {
  'use strict';
  
  const SWIPE_THRESHOLD = 40;
  const TRANSITION_DURATION = '0.3s';
  const INIT_DELAY = 150;
  
  let initTimeout = null;
  let initializedCards = new WeakSet(); // Evitar re-inicialización
  
  // Inicializar solo en DOMContentLoaded
  document.addEventListener('DOMContentLoaded', () => {
    setTimeout(initCarousels, INIT_DELAY);
  });
  
  // Shopify events
  document.addEventListener('shopify:section:load', () => {
    setTimeout(initCarousels, INIT_DELAY);
  });

  function initCarousels() {
    // Limpiar primero
    cleanOrphanedElements();
    
    // Obtener solo cards visibles y no inicializadas
    const cards = document.querySelectorAll('.product-card');
    
    cards.forEach(card => {
      // Verificar que no esté ya inicializada
      if (initializedCards.has(card)) {
        return;
      }
      
      // Verificar que esté visible
      if (card.offsetParent === null) {
        return;
      }
      
      // Verificar que tenga el DOM completo
      const track = card.querySelector('.product-card__carousel-track');
      const slides = card.querySelectorAll('.product-card__slide');
      
      if (!track || slides.length === 0) {
        return;
      }
      
      // Marcar como inicializada
      initializedCards.add(card);
      initCarousel(card);
    });
  }

  function cleanOrphanedElements() {
    // Eliminar dots huérfanos
    document.querySelectorAll('.product-card__dots').forEach(dot => {
      const isInsideWrapper = dot.closest('.product-card__carousel-wrapper');
      const isInsideCard = dot.closest('.product-card');
      
      if (!isInsideWrapper || !isInsideCard) {
        dot.remove();
      }
    });
    
    // Eliminar product-cards vacías (sin carousel-track)
    document.querySelectorAll('.product-card').forEach(card => {
      const track = card.querySelector('.product-card__carousel-track');
      if (!track) {
        console.warn('🗑️ Eliminando card vacía:', card);
        card.remove();
      }
    });
  }

  function initCarousel(card) {
    const track = card.querySelector('.product-card__carousel-track');
    const slides = card.querySelectorAll('.product-card__slide');
    const dots = card.querySelectorAll('.product-card__dot');
    const prevBtn = card.querySelector('.product-card__carousel-arrow--prev');
    const nextBtn = card.querySelector('.product-card__carousel-arrow--next');
    const dotsContainer = card.querySelector('.product-card__dots');

    // Si solo hay 1 imagen, ocultar controles
    if (slides.length < 2) {
      if (dotsContainer) dotsContainer.style.display = 'none';
      if (prevBtn) prevBtn.style.display = 'none';
      if (nextBtn) nextBtn.style.display = 'none';
      return;
    }

    applyMinimalStyles(track, slides);

    let currentIndex = 0;
    let touchStartX = null;
    let touchStartY = null;
    let isDragging = false;

    function goToSlide(index) {
      currentIndex = Math.max(0, Math.min(index, slides.length - 1));
      track.style.transform = `translateX(-${currentIndex * 100}%)`;
      updateDots();
      updateButtons();
    }

    function updateDots() {
      dots.forEach((dot, i) => {
        dot.classList.toggle('active', i === currentIndex);
      });
    }

    function updateButtons() {
      if (prevBtn) prevBtn.disabled = currentIndex === 0;
      if (nextBtn) nextBtn.disabled = currentIndex === slides.length - 1;
    }

    // Botones
    if (prevBtn) {
      prevBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        goToSlide(currentIndex - 1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        goToSlide(currentIndex + 1);
      });
    }

    // Dots
    dots.forEach((dot, i) => {
      dot.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        goToSlide(i);
      });
    });

    // Touch events
    track.addEventListener('touchstart', (e) => {
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
      isDragging = false;
    }, { passive: true });

    track.addEventListener('touchmove', (e) => {
      if (!touchStartX || !touchStartY) return;

      const deltaX = Math.abs(e.touches[0].clientX - touchStartX);
      const deltaY = Math.abs(e.touches[0].clientY - touchStartY);

      if (deltaX > deltaY && deltaX > 10) {
        isDragging = true;
      }
    }, { passive: true });

    track.addEventListener('touchend', (e) => {
      if (touchStartX === null || !isDragging) {
        touchStartX = null;
        touchStartY = null;
        isDragging = false;
        return;
      }

      const touchEndX = e.changedTouches[0].clientX;
      const deltaX = touchEndX - touchStartX;

      if (Math.abs(deltaX) > SWIPE_THRESHOLD) {
        e.preventDefault();
        e.stopPropagation();
        goToSlide(currentIndex + (deltaX > 0 ? -1 : 1));
      }

      touchStartX = null;
      touchStartY = null;
      isDragging = false;
    });

    // Mouse drag (desktop)
    if (window.innerWidth >= 1000) {
      let mouseStartX = null;
      let isMouseDragging = false;

      track.addEventListener('mousedown', (e) => {
        mouseStartX = e.clientX;
        isMouseDragging = false;
        track.style.cursor = 'grabbing';
      });

      track.addEventListener('mousemove', (e) => {
        if (mouseStartX === null) return;
        const deltaX = Math.abs(e.clientX - mouseStartX);
        if (deltaX > 10) isMouseDragging = true;
      });

      track.addEventListener('mouseup', (e) => {
        if (mouseStartX === null) return;

        const mouseEndX = e.clientX;
        const deltaX = mouseEndX - mouseStartX;

        if (isMouseDragging && Math.abs(deltaX) > SWIPE_THRESHOLD) {
          e.preventDefault();
          e.stopPropagation();
          goToSlide(currentIndex + (deltaX > 0 ? -1 : 1));
        }

        mouseStartX = null;
        isMouseDragging = false;
        track.style.cursor = 'grab';
      });

      track.addEventListener('mouseleave', () => {
        mouseStartX = null;
        isMouseDragging = false;
        track.style.cursor = 'grab';
      });
    }

    goToSlide(0);
  }

  function applyMinimalStyles(track, slides) {
    track.style.display = 'flex';
    track.style.transition = `transform ${TRANSITION_DURATION} ease`;
    track.style.cursor = 'grab';
    
    slides.forEach(slide => {
      slide.style.flex = '0 0 100%';
      slide.style.userSelect = 'none';
    });
  }
})();